import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { COMPANY_PROFILE_CARD_DATA_TOKEN, CrmInjectionToken } from '@galaxy/crm/static';
import { MatCardModule } from '@angular/material/card';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { ActiveItemsModule } from '@galaxy/inventory-ui';
import { CrmMarketplaceProductsAssociationCardService } from './marketplace-products.service';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';

const defaultMarket = 'default';

@Component({
  selector: 'crm-marketplace-products-association-card',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatCardModule,
    GalaxyBadgeModule,
    ActiveItemsModule,
    GalaxyAvatarModule,
    GalaxyLoadingSpinnerModule,
  ],
  templateUrl: './marketplace-products.component.html',
  styleUrls: ['../association-panel-shared.scss', './marketplace-products.component.scss'],
  providers: [CrmMarketplaceProductsAssociationCardService],
})
export class CrmMarketplaceProductsAssociationCardComponent {
  private readonly service = inject(CrmMarketplaceProductsAssociationCardService);
  private readonly data = inject(COMPANY_PROFILE_CARD_DATA_TOKEN);
  private readonly config = inject(CrmInjectionToken);

  protected readonly products = toSignal(this.service.products$);
  protected readonly isLoaded = computed(() => this.products() !== undefined);
  protected readonly hasProducts = computed(() => !!this.products()?.length);
  protected readonly hasFailed = toSignal(this.service.getProductsFailed$);

  constructor() {
    this.config.namespace$.pipe(takeUntilDestroyed()).subscribe((partnerId) => this.service.setPartnerId(partnerId));
    this.service.setAccountGroupId(this.data.account_group_id ?? '');
    this.service.setMarketId(this.data.group_id || defaultMarket);
  }
}
